export default {
  en: {
    PLATFORM_ACCOUNT_LABEL: 'Select Account',
    PLATFORM_ACCOUNT_PH: 'Select Account',
    PLATFORM_ACCOUNT_TT: 'Please select an account',
    PLATFORM_AD_ACCOUNT_LABEL: 'Select Ad Account',
    PLATFORM_AD_ACCOUNT_PH: 'Select Ad Account',
    PLATFORM_AD_ACCOUNT_TT: 'Please select an ad account where you\'ll send conversions',
    PLATFORM_AUTHORIZE_BTN: 'Authorize',
    PLATFORM_AUTHORIZE_LABEL: 'Enable integration',
    PLATFORM_AUTHORIZE_TT: 'Please authorize us for integration with the platform.',
    PLATFORM_BUSINESS_MANAGER_LABEL: 'Select Business Manager',
    PLATFORM_BUSINESS_MANAGER_PH: 'Select Business Manager',
    PLATFORM_BUSINESS_MANAGER_TT: 'Please select a business manager for this integration',
    PLATFORM_INTEGRATION_SUCCESS_UPDATE: 'Successfully updated the integration',
    DELETE_PLATFORM_INTEGRATION_MODAL_CHECK_ASSOCIATION_TEXT: 'Determining if this integration is currently associated with any {items}',
    DELETE_PLATFORM_INTEGRATION_MODAL_CHECK_ASSOCIATION_ITEMS: 'Campaigns.',
    DELETE_PLATFORM_INTEGRATION_MODAL_CHECK_ASSOCIATION_ERROR_TEXT: 'An error occurred while determining associated Campaigns. Please try again',
    DELETE_PLATFORM_INTEGRATION_MODAL_NONE_ASSOCIATION_TEXT: 'The integration {integrationName}, is not associated with any Campaigns.',
    DELETE_PLATFORM_INTEGRATION_MODAL_CONFIRM_QUESTION: 'Are you sure you want to delete this integration?',
    DELETE_PLATFORM_INTEGRATION_MODAL_ASSOCIATION_TEXT: '{integrationName} is currently associated with the following items:',
    DELETE_PLATFORM_INTEGRATION_MODAL_TITLE: 'Delete Integration',
    DELETE_PLATFORM_INTEGRATION_CHECKBOX: 'Confirm to delete this integration from all Campaigns',
    DELETE_PLATFORM_INTEGRATION_SUCCESSFUL_MESSAGE: 'Integration deleted successfully',
    PLATFORM_NAME_LABEL: 'Name',
    PLATFORM_NAME_PH: 'Enter Name',
    PLATFORM_NAME_TT: 'You can use this name as a reference throughout the site.',
    PLATFORM_TYPE_LABEL: 'Platform',
    PLATFORM_TYPE_PH: 'Select Platform',
    PLATFORM_TYPE_TT: 'Please select the platform with which you want to integrate.',
    PLATFORMS_ADD_BUTTON: 'Add Platform Integration',
    PLATFORMS_HEADER_NONE: 'You have not added any integrations to platforms.',
    PLATFORMS_STATUS: 'Status',
    PLATFORMS_TITLE: 'Platforms',
    PLATFORMS_TYPE: 'Type',
    PLATFORM_SUB_MCC_ACCOUNT_LABEL: 'Select Sub-Account (optional)',
    PLATFORM_SUB_MCC_ACCOUNT_PH: 'Select Sub-Account',
    PLATFORM_SUB_MCC_ACCOUNT_TT: 'Please select an account',
    PLATFORMS_TABLE_LOADING: 'Loading Platform Integrations',
    REGISTERING: 'Registering',
    LOADING_ACCOUNTS: 'Loading Accounts',
    LOADING_SUB_ACCOUNTS: 'Loading Sub Accounts',
    LOADING_BUSINESS_MANAGER_LIST: 'Loading Business Manager List',
    PLATFORM_TOKEN_REFRESHED: 'Token Has Been Refreshed',
    OAUTH_AUTHORIZATION_SUCCESS: 'Thank you for authorizing {platform} access.',
    OAUTH_CONNECTION_FAILED: 'Connection failed. Please try again.',
  }
};
